import { IAppState } from '../../redux';
import { selectOfferCategory } from './selectOfferCategory';

export function selectIsSaleOffer(state: IAppState): boolean {
  const category = selectOfferCategory(state);

  return !!category?.includes('Sale');
}
